// Small pieces shared by the catalogue rows and the badge panel.
import React from "react";
import { tierStyle } from "../art";
import { holdersFact, tierLabel } from "../collection/badgeFormat";
import type { AdminBadge } from "./adminTypes";

export function TierChip({ tier }: { tier: string }) {
  const s = tierStyle(tier);
  return (
    <span className="badm-tier" style={{ background: s.fill, color: s.ink }}>
      {tierLabel(tier)}
    </span>
  );
}

export function Markers({ badge }: { badge: AdminBadge }) {
  return (
    <>
      {badge.repeatable && <span className="badm-mark badm-mark--repeat">repeatable</span>}
      {badge.unique && <span className="badm-mark badm-mark--unique">unique</span>}
      {!badge.active && <span className="badm-mark badm-mark--off">inactive</span>}
    </>
  );
}

/**
 * How many members hold it: "4 of 41 members have it." The tier chip next to it
 * is the rarity; the engine's rarity classes are not named anywhere in the SPA.
 */
export function HoldersCell({ badge }: { badge: AdminBadge }) {
  const s = badge.stats;
  if (!s) return <span className="badm-muted badm-rarity__none">not counted yet</span>;
  const fact = holdersFact({ holders: s.holders, members: s.members, held: false }) || "Nobody has it yet.";
  return (
    <span className="badm-rarity">
      <span className={`badm-rarity__count${s.holders ? "" : " badm-muted"}`}>{fact}</span>
    </span>
  );
}
